import React, { useState, useEffect } from 'react';
import styles from './landingPage.module.css'

const Landing = () => {
  // determined if page has scrolled and if the view is on mobile

  const [scrollPosition, setSrollPosition] = useState(0);
  const handleScroll = () => {
      const position = window.pageYOffset;
      console.log(position)
      console.log('innerheight',window.innerHeight);
      if(position < (window.innerHeight/3)){
        setSrollPosition(position/4);
      } 
  };
  
  useEffect(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);
  console.log('scrollPosition',scrollPosition);
  return (
    <div className={styles.landingContainer}>
      <div className={styles.landingSection}>
        <div className={styles.landingHeaderText}>
        <div className={styles.landingHeader}>
          <div style={{ transform: `translate(${scrollPosition}px, 0px)`}}>I am a</div>
          </div>
        <div className={styles.landingHeaderRight}>
        <div style={{ transform: `translate(-${scrollPosition}px, 0px)`}}>Full Stack</div>
        </div>
        <div className={styles.landingHeader}>
          <div style={{ transform: `translate(${scrollPosition}px, 0px)`}}>Engineer</div>
        </div>
        </div>
      </div>
      <div>
      <div className={styles.mainIntro}>
        <div className={styles.IntroText}>
          Hello! My name is Ajay Doddapaneni, and I am a Full Stack Engineer with focus on JavaScript. I received my Master's in Information Technology Management and Electrical Engineering. I am from India, currently based in Washington D.C. Metropolitan Area.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;